export class RecaptchaService {
    static getCaptchaResponse(elementId = 'g-recaptcha') {
        const grecaptcha = window.grecaptcha;
        const widgetId = this.widgetIds[elementId];
        if (typeof grecaptcha?.getResponse === 'function'
            && widgetId !== undefined) {
            return grecaptcha.getResponse(widgetId);
        }
        const element = document.getElementById('g-recaptcha-response');
        return element?.value ?? '';
    }
    static resetCaptcha(elementId = 'g-recaptcha') {
        const grecaptcha = window.grecaptcha;
        const widgetId = this.widgetIds[elementId];
        if (typeof grecaptcha?.reset === 'function') {
            grecaptcha.reset(widgetId);
        }
    }
    static initRecaptcha(elementId = 'g-recaptcha', retryDelayMilliseconds = 100) {
        if (!document.getElementById(elementId)
            || Object.prototype.hasOwnProperty.call(this.widgetIds, elementId)) {
            return;
        }
        const grecaptcha = window.grecaptcha;
        if (typeof grecaptcha?.render !== 'function') {
            window.setTimeout(() => this.initRecaptcha(elementId, retryDelayMilliseconds), retryDelayMilliseconds);
            return;
        }
        this.widgetIds[elementId] = grecaptcha.render(elementId, {
            sitekey: '6LdtbAITAAAAAJ1ew5joky0iZVeNDJY3MQZNmQSU',
            theme: 'light'
        });
    }
}
RecaptchaService.widgetIds = {};
